import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Basier Circle', -apple-system, "Helvetica Neue", Helvetica, "Segoe UI", Arial, sans-serif;
    font-size: 16px;
    touch-action: pan-y;
    -webkit-font-smoothing: antialiased;
  }

  @font-face {
    font-family: 'Basier Circle';
    font-display: swap;
    font-weight: 400;
    src: url('/ui/fonts/BasierCircle-Regular.woff2') format("woff2");
  }

  @font-face {
    font-family: 'Basier Circle';
    font-weight: 500;
    font-display: swap;
    src: url('/ui/fonts/BasierCircle-Medium.woff2') format("woff2");
  }

  @font-face {
    font-family: 'Basier Circle';
    font-weight: 600;
    font-display: swap;
    src: url('/ui/fonts/BasierCircle-SemiBold.woff2') format("woff2");
  }

  @font-face {
    font-family: 'Futura New';
    src: local('Futura New Light'),
        url('/ui/fonts/FuturaNewLight.woff2') format('woff2'),
        url('/ui/fonts/FuturaNewLight.woff') format('woff');
    font-weight: 100;
    font-display: swap;
    }
  @font-face {
    font-family: 'Futura New';
    src: local('Futura New Book'),
        url('/ui/fonts/FuturaNewBook.woff2') format('woff2'),
        url('/ui/fonts/FuturaNewBook.woff') format('woff'),
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: 'Futura New';
    src: local('Futura New Medium'),
        url('/ui/fonts/FuturaNewMedium.woff2') format('woff2'),
        url('/ui/fonts/FuturaNewMedium.woff') format('woff');
    font-weight: 500;
    font-display: swap;
  }
  @font-face {
    font-family: 'Futura New';
    src: local('Futura New Bold'),
        url('/ui/fonts/FuturaNewBold.woff2') format('woff2'),
        url('/ui/fonts/FuturaNewBold.woff') format('woff');
    font-weight: 600;
    font-display: swap;
  }
  @keyframes shake {
    8%, 41% {
        -webkit-transform: translateX(-10px);
    }
    25%, 58% {
        -webkit-transform: translateX(10px);
    }
    75% {
        -webkit-transform: translateX(-5px);
    }
    92% {
        -webkit-transform: translateX(5px);
    }
    0%, 100% {
        -webkit-transform: translateX(0);
    }
  }
`
